export default __webpack_public_path__ + "static/media/icones_minhas_conexoes.aea83c36.svg";